export default function WaitStatusList({ waitStateItems }) {
  if (!waitStateItems || waitStateItems.length === 0) return null;
  return (
    <div className="alert alert-danger mt-3">
      <h6 className="mb-2">Unavailable Items:</h6>
      <ul className="mb-0">
        {waitStateItems.map((item, idx) => (
          <li key={idx}>
            <strong>{item.foodItemName}</strong> at {item.restaurantName}
          </li>
        ))}
      </ul>
    </div>
  );
}
